import WorkflowStep from "./workflowStep";
import {WorkflowType} from "~/enums/forms/workflowSteps/workflowType";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import {LicenseApplicationType} from "../../enums/licenseApplicationType";
import {LicenseApplicationTypeName} from "../../enums/licenseApplicationTypeName";
import PaymentStepValidation from "../../../../common/models/navigableValidations/paymentStepValidation";
import CertificateStepValidation from "../../../../common/models/navigableValidations/certificateStepValidation";
import Validatable from "../../../../common/mixins/validatable";
import {PermitteeType} from "~/enums/permitteeType";

export default class CertificateStep extends Validatable(WorkflowStep) implements WorkflowStepInterface {
  certificate_id: string;
  certificate: any;

  constructor(form?) {
    super(form);
    this.defineProperty('workflow_type', WorkflowType.certificate);
    this.defineProperty('certificate_id', '');
  }

  get UNTRACKED_PROPERTIES(): string[] {
    return ['certificate'];
  }

  //***** validation ***** //
  _validation: CertificateStepValidation = new CertificateStepValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      default:
        return propName;
      // return this.attributes_metadata[propName].display_name;
    }
  }
  //***** validation end ***** //

  get titleOrDefault(): string {
    if (this.hasTitle) {
      return this.title;
    } else {
      let suffix = 'Certificate';
      if (this.certificate && this.certificate.title) {
        suffix = this.certificate.title;
      }
      return `Generate ${suffix}`;
    }
  }

  createDefaultViewers(): void {
    this.appendViewer({
      reference_id: PermitteeType.originalSubmitter.toString(),
      reference_type: PermitteeType.originalSubmitter
    });
  }

}